"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementOuterWidth = exports.getElementOuterHeight = exports.getElementWidth = exports.getElementHeight = void 0;
function getSize(el, prop) {
    return parseFloat(getComputedStyle(el, null)[prop].replace('px', ''));
}
function outerSize(el, prop, includeMargin) {
    if (includeMargin === void 0) { includeMargin = false; }
    var isHeight = prop === 'height';
    var value = isHeight ? el.offsetHeight : el.offsetWidth;
    if (!includeMargin) {
        return value;
    }
    var style = getComputedStyle(el);
    if (isHeight) {
        value += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    }
    else {
        value += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    }
    return value;
}
var getElementHeight = function (el) { return getSize(el, 'height'); };
exports.getElementHeight = getElementHeight;
var getElementWidth = function (el) { return getSize(el, 'width'); };
exports.getElementWidth = getElementWidth;
var getElementOuterHeight = function (el, includeMargin) {
    if (includeMargin === void 0) { includeMargin = false; }
    return outerSize(el, 'height', includeMargin);
};
exports.getElementOuterHeight = getElementOuterHeight;
var getElementOuterWidth = function (el, includeMargin) {
    if (includeMargin === void 0) { includeMargin = false; }
    return outerSize(el, 'width', includeMargin);
};
exports.getElementOuterWidth = getElementOuterWidth;
//# sourceMappingURL=get-element-size.js.map